import { useState } from "react";
import rodrimaq_icon from '../../assets/img/Alternative_logo.png';



export function NavbarHeader({ navbarOpen, setnavbarOpen }: { navbarOpen: boolean, setnavbarOpen: any }) {

    const [imageHovered, setImageHovered] = useState(false);


    return (
        <div className='flex items-center justify-center h-16'>
            {navbarOpen ? <h1 className='font-bold mr-5 text-[1.6em]'>Rodrimaq</h1> : null}

            <div className='cursor-pointer' onClick={(e) => { setnavbarOpen(!navbarOpen); e.stopPropagation() }} onMouseEnter={() => setImageHovered(true)} onMouseLeave={() => setImageHovered(false)}>
                <img className="hover:animate-spin" src={rodrimaq_icon} width={40} height={40} />
            </div>
        </div>
    )


}